function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M11.2604 0H13.9692C15.091 0 16 0.916681 16 2.04797V4.77962C16 5.91091 15.091 6.82759 13.9692 6.82759H11.2604C10.1386 6.82759 9.22961 5.91091 9.22961 4.77962V2.04797C9.22961 0.916681 10.1386 0 11.2604 0Z",
  fill: "white"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "white",
  opacity: 0.5,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.03082 0H4.73959C5.86141 0 6.77041 0.916681 6.77041 2.04797V4.77962C6.77041 5.91091 5.86141 6.82759 4.73959 6.82759H2.03082C0.909004 6.82759 0 5.91091 0 4.77962V2.04797C0 0.916681 0.909004 0 2.03082 0ZM2.03082 9.17231H4.73959C5.86141 9.17231 6.77041 10.089 6.77041 11.2203V13.9519C6.77041 15.0825 5.86141 15.9999 4.73959 15.9999H2.03082C0.909004 15.9999 0 15.0825 0 13.9519V11.2203C0 10.089 0.909004 9.17231 2.03082 9.17231ZM13.9692 9.17231H11.2604C10.1386 9.17231 9.22959 10.089 9.22959 11.2203V13.9519C9.22959 15.0825 10.1386 15.9999 11.2604 15.9999H13.9692C15.091 15.9999 16 15.0825 16 13.9519V11.2203C16 10.089 15.091 9.17231 13.9692 9.17231Z",
  fill: "white"
});

function SvgOverviewIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverviewIcon);
export default __webpack_public_path__ + "static/media/overviewIcon.9df9f901.svg";
export { ForwardRef as ReactComponent };